// Sentry configuration for TanStack Router
// https://docs.sentry.io/platforms/javascript/guides/react/features/tanstack-router

import * as Sentry from "@sentry/react";
import { router } from "./src/router";

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  dsn:
    SENTRY_DSN ||
    "https://48668ced5203433997a9da447104d868@o1418254.ingest.sentry.io/6776393",
  enabled: process.env.NODE_ENV !== "development",
  enableLogs: true,
  integrations: [Sentry.tanstackRouterBrowserTracingIntegration(router)],
  tracesSampleRate: 1.0,
});
